import { createIcon } from '~/utils';

export const GoogleIcon = createIcon({
  viewBox: '0 0 16 16',
  path: [
    <g clipPath='url(#clip0_11_42)'>
      <path
        fill='#4285f4'
        d='M15.8409 8.18077C15.8409 7.52508 15.7857 7.04098 15.6693 6.54462H8.1626V9.51053H12.5686C12.4828 10.2459 11.9987 11.3612 10.9324 12.1088L10.9202 12.2068L13.2978 14.0452L13.4632 14.0636C14.9707 12.6664 15.8409 10.6136 15.8409 8.18077Z'
      />
      <path
        fill='#34a853'
        d='M8.16249 16C10.3195 16 12.1334 15.2892 13.4631 14.0636L10.9384 12.1088C10.2644 12.5806 9.35743 12.9115 8.16249 12.9115C6.04836 12.9115 4.25288 11.5144 3.60944 9.59021L3.51753 9.59634L1.04797 11.5082L1.01733 11.6002C2.32871 14.2045 5.03112 16 8.16249 16Z'
      />
      <path
        fill='#fbbc05'
        d='M3.60944 9.58406C3.43786 9.0877 3.33981 8.55457 3.33981 8.00306C3.33981 7.45155 3.43786 6.91842 3.59719 6.42206L3.59106 6.31788L1.097 4.3692L1.01733 4.40597C0.471948 5.49061 0.159424 6.71007 0.159424 8.00306C0.159424 9.29605 0.471948 10.5094 1.0112 11.594L3.60944 9.58406Z'
      />
      <path
        fill='#eb4335'
        d='M8.16251 3.0946C9.66385 3.0946 10.6811 3.74416 11.2571 4.28342L13.5122 2.07736C12.1212 0.790502 10.3195 0 8.16251 0C5.03115 0 2.32873 1.79548 1.01123 4.40597L3.59721 6.41593C4.24677 4.49177 6.04225 3.0946 8.16251 3.0946Z'
      />
    </g>,
    <defs>
      <clipPath id='clip0_11_42'>
        <rect
          height='16'
          fill='white'
          width='15.6813'
          transform='translate(0.159424)'
        />
      </clipPath>
    </defs>,
  ],
});
